/**
    This file is autogenerated using the command `yarn app-store:build --watch`.
    Don't modify this file manually.
**/
import dynamic from "next/dynamic";
export const InstallAppButtonMap = {
	exchange2013calendar: dynamic(
		() => import("./exchange2013calendar/components/InstallAppButton"),
	),
	exchange2016calendar: dynamic(
		() => import("./exchange2016calendar/components/InstallAppButton"),
	),
	office365video: dynamic(
		() => import("./office365video/components/InstallAppButton"),
	),
	vital: dynamic(() => import("./vital/components/InstallAppButton")),
};
export const AppSettingsComponentsMap = {
	"general-app-settings": dynamic(
		() =>
			import(
				"./templates/general-app-settings/components/AppSettingsInterface"
			),
	),
	weather_in_your_calendar: dynamic(
		() => import("./weather_in_your_calendar/components/AppSettingsInterface"),
	),
	zapier: dynamic(() => import("./zapier/components/AppSettingsInterface")),
};
export const EventTypeAddonMap = {
	alby: dynamic(() => import("./alby/components/EventTypeAppCardInterface")),
	alma: dynamic(() => import("./alma/components/EventTypeAppCardInterface")),
	basecamp3: dynamic(
		() => import("./basecamp3/components/EventTypeAppCardInterface"),
	),
	btcpayserver: dynamic(
		() => import("./btcpayserver/components/EventTypeAppCardInterface"),
	),
	closecom: dynamic(
		() => import("./closecom/components/EventTypeAppCardInterface"),
	),
	databuddy: dynamic(
		() => import("./databuddy/components/EventTypeAppCardInterface"),
	),
	fathom: dynamic(
		() => import("./fathom/components/EventTypeAppCardInterface"),
	),
	ga4: dynamic(() => import("./ga4/components/EventTypeAppCardInterface")),
	giphy: dynamic(() => import("./giphy/components/EventTypeAppCardInterface")),
	gowa: dynamic(() => import("./gowa/components/EventTypeAppCardInterface")),
	gtm: dynamic(() => import("./gtm/components/EventTypeAppCardInterface")),
	hitpay: dynamic(
		() => import("./hitpay/components/EventTypeAppCardInterface"),
	),
	hubspot: dynamic(
		() => import("./hubspot/components/EventTypeAppCardInterface"),
	),
	insihts: dynamic(
		() => import("./insihts/components/EventTypeAppCardInterface"),
	),
	matomo: dynamic(
		() => import("./matomo/components/EventTypeAppCardInterface"),
	),
	metapixel: dynamic(
		() => import("./metapixel/components/EventTypeAppCardInterface"),
	),
	"mock-payment-app": dynamic(
		() => import("./mock-payment-app/components/EventTypeAppCardInterface"),
	),
	paypal: dynamic(
		() => import("./paypal/components/EventTypeAppCardInterface"),
	),
	"pipedrive-crm": dynamic(
		() => import("./pipedrive-crm/components/EventTypeAppCardInterface"),
	),
	plausible: dynamic(
		() => import("./plausible/components/EventTypeAppCardInterface"),
	),
	pledg: dynamic(() => import("./pledg/components/EventTypeAppCardInterface")),
	posthog: dynamic(
		() => import("./posthog/components/EventTypeAppCardInterface"),
	),
	qr_code: dynamic(
		() => import("./qr_code/components/EventTypeAppCardInterface"),
	),
	salesforce: dynamic(
		() => import("./salesforce/components/EventTypeAppCardInterface"),
	),
	smsfactor: dynamic(
		() => import("./smsfactor/components/EventTypeAppCardInterface"),
	),
	stripepayment: dynamic(
		() => import("./stripepayment/components/EventTypeAppCardInterface"),
	),
	"booking-pages-tag": dynamic(
		() =>
			import(
				"./templates/booking-pages-tag/components/EventTypeAppCardInterface"
			),
	),
	"event-type-app-card": dynamic(
		() =>
			import(
				"./templates/event-type-app-card/components/EventTypeAppCardInterface"
			),
	),
	twipla: dynamic(
		() => import("./twipla/components/EventTypeAppCardInterface"),
	),
	umami: dynamic(() => import("./umami/components/EventTypeAppCardInterface")),
	"zoho-bigin": dynamic(
		() => import("./zoho-bigin/components/EventTypeAppCardInterface"),
	),
	zohocrm: dynamic(
		() => import("./zohocrm/components/EventTypeAppCardInterface"),
	),
};
export const EventTypeSettingsMap = {
	alby: dynamic(
		() => import("./alby/components/EventTypeAppSettingsInterface"),
	),
	alma: dynamic(
		() => import("./alma/components/EventTypeAppSettingsInterface"),
	),
	basecamp3: dynamic(
		() => import("./basecamp3/components/EventTypeAppSettingsInterface"),
	),
	btcpayserver: dynamic(
		() => import("./btcpayserver/components/EventTypeAppSettingsInterface"),
	),
	databuddy: dynamic(
		() => import("./databuddy/components/EventTypeAppSettingsInterface"),
	),
	fathom: dynamic(
		() => import("./fathom/components/EventTypeAppSettingsInterface"),
	),
	ga4: dynamic(() => import("./ga4/components/EventTypeAppSettingsInterface")),
	giphy: dynamic(
		() => import("./giphy/components/EventTypeAppSettingsInterface"),
	),
	gowa: dynamic(
		() => import("./gowa/components/EventTypeAppSettingsInterface"),
	),
	gtm: dynamic(() => import("./gtm/components/EventTypeAppSettingsInterface")),
	hitpay: dynamic(
		() => import("./hitpay/components/EventTypeAppSettingsInterface"),
	),
	metapixel: dynamic(
		() => import("./metapixel/components/EventTypeAppSettingsInterface"),
	),
	paypal: dynamic(
		() => import("./paypal/components/EventTypeAppSettingsInterface"),
	),
	plausible: dynamic(
		() => import("./plausible/components/EventTypeAppSettingsInterface"),
	),
	pledg: dynamic(
		() => import("./pledg/components/EventTypeAppSettingsInterface"),
	),
	qr_code: dynamic(
		() => import("./qr_code/components/EventTypeAppSettingsInterface"),
	),
	smsfactor: dynamic(
		() => import("./smsfactor/components/EventTypeAppSettingsInterface"),
	),
	stripepayment: dynamic(
		() => import("./stripepayment/components/EventTypeAppSettingsInterface"),
	),
};
